export { Prism as default } from './Prism';
